






























































































import Vue from "vue";
import BaseMediaTimeSlider from "@/app/shared/components/base/BaseMediaTimeSlider.vue";
import utils from "@/app/shared/utils/utils.js";

export default Vue.extend({
  name: "RendersPreviewWindow",
  components: {
    BaseMediaTimeSlider,
  },
  mixins: [utils],
  data: function () {
    return {
      currentItem: null,
      mutedStateBeforeOpen: true,
      localMuted: true,
      duration: 0,
      currentTime: 0,
      isPlaying: true,
      wasPlaying: false,
      isOpenControllers: false,
      timer: null,
      dragStart: false,
      videoTimeIntervalListner: null,
      muted: true,
    };
  },
  props: {
    initialItem: {
      type: Object,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
  },
  computed: {
    keymap: function () {
      return {
        esc: this.exit,
        "ctrl+left": this.swipeLeft,
        "command+left": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeLeft();
        },
        "ctrl+right": this.swipeRight,
        "command+right": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeRight();
        },
        space: {
          keyup: (event) => {
            event.stopPropagation();
            if (!this.dragStart) {
              this.playOrPause();
            }
          },
        },
      };
    },
  },

  created() {},
  mounted() {
    this.onOpen();
  },
  methods: {
    downloadFile() {
      const downloadHref = this.currentItem.downloadPath;
      const link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link); // Firefox requires the link to be in the body
      link.download = this.currentItem.name;
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link);
    },
    onMouseOver() {
      this.isOpenControllers = true;
    },
    onMouseLeave() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isOpenControllers = false;
      }, 5000);
    },
    getTimeDisplay() {
      const duration = !this.duration ? 0 : this.duration;

      return (
        this.convertSecondsToTimeboardStyle(this.currentTime) +
        " / " +
        this.convertSecondsToTimeboardStyle(duration)
      );
    },
    startChangeTime() {
      this.dragStart = true;
      if (this.isPlaying) {
        this.wasPlaying = true;
        this.playOrPause();
      }
    },
    changeTime(time) {
      this.setNewTime(time);
    },
    stopChangeTime() {
      this.dragStart = false;
      if (this.wasPlaying) {
        this.wasPlaying = false;
        this.playOrPause();
      }
    },
    playOrPause() {
      this.isPlaying = !this.isPlaying;
      this.isPlaying
        ? this.$refs.renderedVideo.play()
        : this.$refs.renderedVideo.pause();
      if (!this.isOpenControllers) {
        this.onMouseOver();
        this.onMouseLeave();
      }
    },
    setNewTime(videoTime) {
      this.currentTime = videoTime;
      this.$refs.renderedVideo.currentTime = videoTime;
    },
    onOpen() {
      this.currentItem = this.initialItem;
      this.mutedStateBeforeOpen = this.muted;
      this.localMuted = this.muted;
      this.muted = true;

      this.videoTimeIntervalListner = setInterval(() => {
        if (!this.$refs.renderedVideo) {
          this.duration = 0;
          this.currentTime = 0;
        } else {
          this.duration = this.$refs.renderedVideo.duration;
          this.currentTime = this.$refs.renderedVideo.currentTime;
        }
      }, 40);
    },
    exit() {
      this.muted = this.mutedStateBeforeOpen;
      this.currentItem = null;
      this.duration = 0;
      this.currentTime = 0;
      clearInterval(this.videoTimeIntervalListner);
      this.$emit("close");
    },
    swipeLeft() {
      if (this.currentItem !== this.files[0]) {
        const itemIndex = this.files.indexOf(this.currentItem);
        const leftIndex =
          itemIndex === 0 ? this.files.length - 1 : itemIndex - 1;
        this.currentItem = this.files[leftIndex];
      }
    },
    swipeRight() {
      if (this.currentItem !== this.files[this.files.length - 1]) {
        let itemIndex = this.files.indexOf(this.currentItem);
        let rightIndex =
          itemIndex === this.files.length - 1 ? 0 : itemIndex + 1;
        this.currentItem = this.files[rightIndex];
      }
    },
  },
});
